import React, { useEffect, useRef } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';

const MapComponent = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    // 清理之前的地图实例
    if (mapInstanceRef.current) {
      mapInstanceRef.current.destroy();
    }

    AMapLoader.load({
      key: '1c0ad18ecbb037af8091b1e8531de88a', // 您的高德地图API Key
      version: '2.0',
      plugins: ['AMap.Marker', 'AMap.InfoWindow']
    }).then((AMap) => {
      // 创建地图实例
      const map = new AMap.Map(mapRef.current, {
        zoom: 16,
        center: [115.779159, 33.826231], // 亳州市谯城区坐标
        mapStyle: 'amap://styles/normal'
      });

      mapInstanceRef.current = map;

      // 创建标记点
      const marker = new AMap.Marker({
        position: [115.779159, 33.826231],
        title: '云帐天下',
        icon: new AMap.Icon({
          size: new AMap.Size(25, 34),
          image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png'
        })
      });

      // 添加标记到地图
      map.add(marker);

      // 创建信息窗体
      const infoWindow = new AMap.InfoWindow({
        content: `
          <div style="padding: 10px; font-family: Arial, sans-serif;">
            <h3 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">云帐天下</h3>
            <p style="margin: 0; color: #666; font-size: 14px; line-height: 1.4;">
              安徽省亳州市谯城区<br>
              高新万达B座写字楼16层
            </p>
          </div>
        `,
        offset: new AMap.Pixel(0, -30)
      });

      // 点击标记显示信息窗体
      marker.on('click', () => {
        infoWindow.open(map, marker.getPosition());
      });

      // 地图加载完成后自动显示信息窗体
      map.on('complete', () => {
        setTimeout(() => {
          infoWindow.open(map, marker.getPosition());
        }, 1000);
      });

    }).catch((error) => {
      console.error('地图加载失败:', error);
      // 显示错误信息
      if (mapRef.current) {
        mapRef.current.innerHTML = `
          <div style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            background-color: #f5f5f5;
            color: #666;
            font-size: 14px;
          ">
            地图加载失败，请稍后重试
          </div>
        `;
      }
    });

    // 清理函数
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.destroy();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className="w-full">
      <div 
        ref={mapRef}
        className="w-full h-96 rounded-lg shadow-lg border border-gray-200"
        style={{ minHeight: '400px' }}
      >
        <div className="flex items-center justify-center h-full bg-gray-100 text-gray-500">
          地图加载中...
        </div>
      </div>
      
      {/* 地址信息 */}
      <div className="mt-4 p-4 bg-gray-50 rounded-lg">
        <h4 className="text-lg font-semibold text-gray-800 mb-2">公司地址</h4>
        <p className="text-gray-600 leading-relaxed">
          安徽省亳州市谯城区高新万达B座写字楼16层
        </p>
        <div className="mt-3 flex items-center text-sm text-gray-500">
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
          点击地图标记查看详细位置信息
        </div>
      </div>
    </div>
  );
};

export default MapComponent;